import api from '../utils/api';

export default {
  state: () => ({
    topics: null,
  }),
  mutations: {
    setTopics(state, topics) {
      state.topics = topics;
    },
  },
  getters: {},
  actions: {
    async getAllTopics({commit}) {
      const {data} = await api.http.get('admin/topics')
      commit('setTopics', data.data)
    },
    async getTopicById(_, id) {
      const {data} = await api.http.get(`/admin/topics/${id}`)

      return data
    },
    async createTopic({dispatch}, {formData}) {
      const {data} = await api.http.post('/admin/topics', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      dispatch('getAllTopics')
      return data
    },
    async editTopic({dispatch}, {formData, id}) {
      const {data} = await api.http.post(`/admin/topics/${id}/update`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      dispatch('getAllTopics')
      return data
    },

    async deleteTopic({dispatch}, id) {
      const {data} = await api.http.delete(`/admin/topics/${id}`)
      dispatch('getAllTopics')
      return data
    },
  },
  namespaced: true,
}
